import { endpoints } from '../constants/endpoints';
import {
  ActiveListing,
  EventListingUpdateDto,
  ListingQueryDto,
} from '../constants/types';
import { CrossListingStatus } from '../components/drawer/ActiveListingDetails';

import { BaseApi } from './index';

export class ListingApi extends BaseApi<any> {
  constructor() {
    super(endpoints.listings.base);
  }

  async getActiveListings(query: Partial<ListingQueryDto>) {
    return this.fetch(endpoints.listings.active, { params: query });
  }

  async getSoldListings(query: Partial<ListingQueryDto>) {
    return this.fetch(endpoints.listings.sold, { params: query });
  }

  async getSoldListingById(id: string) {
    return this.get(endpoints.listings.soldById(id));
  }

  async getActiveListingById(id: string) {
    return this.get(endpoints.listings.activeById(id));
  }

  async deleteOrder(id: string) {
    return this.delete(endpoints.listings.orderById(id));
  }

  async deleteListing(id: string) {
    return this.delete(endpoints.listings.activeById(id));
  }

  async deleteAllActiveListingsForUser(userId: string) {
    return this.delete(endpoints.listings.deleteAllUserActiveListings(userId));
  }

  async updateActiveListing(id: string, data: Partial<any>) {
    return this.patch(endpoints.listings.activeById(id), data);
  }

  async cancelOrder(id: string) {
    return this.patch(endpoints.listings.cancelById(id), {});
  }

  async featureListing(id: string, featured: boolean) {
    return (await this.patch(endpoints.listings.featureById(id), {
      featured,
    })) as unknown as { featured: boolean };
  }

  async updateFlashSaleWindow(startTime: string, endTime: string) {
    return this.put(endpoints.listings.flashSaleWindow, {
      startTime,
      endTime,
    });
  }

  async getFlashSaleWindow() {
    return this.get(endpoints.listings.flashSaleWindow);
  }

  async getListingEventGroups() {
    return this.get(endpoints.listings.eventGroups);
  }

  async getEnableBinPosting() {
    return this.get(endpoints.listings.enablePosting);
  }

  async getEnablePurchasing() {
    return this.get(endpoints.listings.enablePurchasing);
  }

  async updateEnablePosting(enabled: boolean) {
    return this.put(endpoints.listings.enablePosting, {
      enablePosting: enabled,
    });
  }

  async updateEnablePurchasing(enabled: boolean) {
    return this.put(endpoints.listings.enablePurchasing, {
      enablePurchasing: enabled,
    });
  }

  async getEventListings(bucketTime: number, groupId: string) {
    return (await this.get(endpoints.listings.eventListings, {
      bucketTime,
      subCategoryIds: groupId.split(','),
    })) as {
      items: ActiveListing[];
      count: number;
    };
  }

  async bulkUpdate(data: EventListingUpdateDto[]) {
    return this.patch(endpoints.listings.bulkUpdate, data);
  }

  async getEbayCrossListStatus(id: string) {
    return (await this.get(
      endpoints.listings.getCrossListStatus(id),
    )) as unknown as { status: CrossListingStatus; errorMessages?: string[] };
  }

  async crossListToEbay(id: string, price: number, inStock: number) {
    return this.post(endpoints.listings.crossList(id), { price, inStock });
  }

  async retryEbayCrossList(id: string) {
    return this.post(endpoints.listings.retryCrossList(id));
  }
}
